import type React from 'react';
import { Divider, FormField, Input, Label } from '@zillow/constellation-10';

import HeaderToggle from './HeaderToggle';
import type { Section } from '../../../../models/index';
import { TRASH_REMOVAL } from '../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

export default function TrashRemoval_v1({ section, setSectionValues }: Props): JSX.Element {
  function onToggleUtility(): void {
    setSectionValues({
      [TRASH_REMOVAL.FIELD_NAME.IS_ENABLED]: !section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED),
    });
  }

  function onServiceProviderChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void {
    setSectionValues({
      [TRASH_REMOVAL.FIELD_NAME.SERVICE_PROVIDER]: event.currentTarget.value,
    });
  }

  return (
    <>
      <HeaderToggle
        header="Trash removal"
        subheader="Tenant pays in addition to base rent"
        switchOn={section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED)}
        onSwitchToggle={onToggleUtility}
      />
      {section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.IS_ENABLED) && (
        <>
          <Divider css={{ marginTop: 'layout.tighter', marginBottom: 'layout.tighter' }} />
          <FormField
            required
            label={
              <Label id="service-provider">
                Your tenant will be responsible for cost and account set up and will pay directly to which service
                provider?
              </Label>
            }
            control={
              <Input
                aria-labelledby="service-provider"
                value={section.getFieldValue(TRASH_REMOVAL.FIELD_NAME.SERVICE_PROVIDER)}
                onChange={onServiceProviderChange}
                data-test="service-provider"
              />
            }
          />
        </>
      )}
    </>
  );
}
